import { inject, Injectable, isDevMode } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TokenService } from 'projects/login/src/app/services/auth/token.service';
import { RedirectService } from 'projects/login/src/app/services/redirect/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly redirectService = inject(RedirectService);
  async canActivate(): Promise<boolean> {
    if (isDevMode()) {
      return true;
    }
    if (!TokenService.sessionId) {
      this.redirectService.goToInvalidSession();
      return false;
    }
    return true;
  }
}
